import { render, staticRenderFns } from "./ArgumentHeading.vue?vue&type=template&id=2c521991&"
import script from "./ArgumentHeading.vue?vue&type=script&lang=js&"
export * from "./ArgumentHeading.vue?vue&type=script&lang=js&"
import style0 from "./ArgumentHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports